import type { AssetId, ShapeId } from './types'

function generateId(len = 12): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const bytes = crypto.getRandomValues(new Uint8Array(len))
  for (const b of bytes) result += chars[b % chars.length]
  return result
}

export function createShapeId(): ShapeId {
  return generateId(12) as ShapeId
}

export function createAssetId(suffix?: string): AssetId {
  return (suffix ? `asset:${suffix}` : `asset:${generateId(12)}`) as AssetId
}
